<template>
  <li
    class="sidebar-item"
    :class="[isActive ? 'text-default' : 'text-default/40', {'bg-active' : isActive && !props.children}]"
    @click="sidebarClick"
  >
    <div
      class="w-1"
      :class="{'bg-active-bar' : isActive}"
    />
    <div class="flex min-w-0 grow items-center justify-between p-2">
      <div class="flex w-full items-center gap-2">
        <EpIcon
          v-if="props.icon"
          :name="props.icon"
        />
        <div
          v-if="props.image"
          class="image-mask"
        />
        <p class="leading-normal">
          {{ props.label }}
        </p>
        <div class="ml-auto flex gap-2">
          <EpIcon
            v-if="props.isExternalLink"
            name="launch"
            :size="20"
            :class="{'text-default/40' : !isActive}"
          />
        </div>
      </div>
    </div>
  </li>
  <template v-if="props.children">
    <SidebarSubMenu
      v-for="menu in props.children"
      :key="menu.value"
      v-bind="{
        ...menu,
        parentUrl: `${props.value}`,
        depth: props.depth + 1,
      }"
    />
  </template>
</template>
<script setup lang="ts">
import EpIcon from '~/components/icon/EpIcon.vue'
import { useSidebar } from '~/composables/useSidebar'
import type { IMenuRoute } from '~/types/sidebar-menu.type'

const props = defineProps<IMenuRoute>()
const { isActive, sidebarClick } = useSidebar(props)

const maskImage = computed(() => props.image ? `url(${props.image})` : 'none')
</script>

<style scoped lang="scss">
.sidebar-item {
  @apply flex w-full cursor-pointer gap-2;
  transition: all 0.3s ease;

  .image-mask {
    @apply w-4 h-4 bg-default/40;
    mask-repeat: no-repeat;
    mask-size: cover;
    mask-image: v-bind(maskImage);
    -webkit-mask-image: v-bind(maskImage);
  }

  &:hover {
    @apply bg-gradient-to-r from-default/10 to-transparent text-default;
    .image-mask {
      @apply bg-default;
    }
  }
}

.bg-active-bar {
  background-color: $primary-color;
}

.bg-active {
  &, &:hover {
    @include background-gradient;
  }
}
</style>
